import {BaseTypedValueType, TypedValue} from 'notebook/tables/TableConstants';
import {FieldType} from 'schemas/fields/SchemaFieldConstants';

export function parseIdFromLookupInputTypedValues(typedValue: TypedValue): Array<string> {
  switch (typedValue.type) {
    case BaseTypedValueType.BIOENTITY:
      return [typedValue.bioentitySummary.id];
    case FieldType.BIOENTITY_LINK:
      // Remove any "Deleted Entities" which have an id that's null
      return typedValue.targetFiles?.filter(({id}) => id != null).map((e) => e.id!) ?? [];
    case FieldType.PART_LINK:
    case FieldType.AA_PART_LINK:
    case FieldType.TRANSLATION_LINK:
    case FieldType.TRANSCRIPTION_LINK:
      // Part links, translation links, and transcription links use targetFiles with guaranteed IDs
      return typedValue.targetFiles?.map((e) => e.id) ?? [];
    case BaseTypedValueType.STORABLES:
      return typedValue.storableSummaries?.map((e) => e.id) ?? [];
    case FieldType.STORABLE_LINK:
      return typedValue.targetStorables?.map((e) => e.id) ?? [];
    case BaseTypedValueType.PROCESS_TASK:
      return [typedValue.id];
    case BaseTypedValueType.ARRAY:
      return typedValue.rawValue?.flatMap((value) => parseIdFromLookupInputTypedValues(value)) ?? [];
    default:
      return [];
  }
}

export function parseTextValueFromLookupInputTypedValue(typedValue: TypedValue): string | null {
  if (typedValue.type === FieldType.TEXT) {
    return typedValue.value;
  }
  return null;
}
